import { Theme } from "@mui/material";

export const getTextFieldSx = (theme: Theme) => {
  return {
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.main
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.main,
      borderWidth: 2
    },
    ...getTextFieldBasicSx(theme)
  };
};

export const getTextFieldBasicSx = (theme: Theme) => {
  return {
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
      backgroundColor: theme.palette.background.paper
    }
  };
};
